module.exports = __webpack_public_path__ + "img/40_38_063_270.7dd19560.jpg";